var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPromotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31479 6.13398C9.31494 6.13384 9.31465 6.13413 9.31479 6.13398L6.13098 9.30669C4.62355 10.8236 4.62212 13.2752 6.13198 14.7865L9.20963 17.867L9.21063 17.868C10.7262 19.3768 13.1755 19.3782 14.6854 17.867L17.8612 14.6882C18.6316 13.9171 19.0448 12.8543 18.9961 11.7596L18.9961 11.7577L18.8277 8.24801C18.7441 6.58163 17.4133 5.24923 15.7402 5.17345C15.7399 5.17343 15.7396 5.17342 15.7393 5.17341L12.2378 5.00518C12.2374 5.00516 12.2371 5.00514 12.2367 5.00512C11.1471 4.94848 10.0844 5.36389 9.31479 6.13398ZM10.0584 6.87825C10.6205 6.31565 11.3943 6.01507 12.183 6.05631L12.1852 6.05642L15.6905 6.22483L15.6921 6.2249C16.8226 6.27582 17.7207 7.1744 17.7775 8.30028C17.7775 8.30047 17.7774 8.3001 17.7775 8.30028L17.9456 11.8063C17.9456 11.8066 17.9456 11.8069 17.9456 11.8072C17.9809 12.6068 17.6789 13.3821 17.1176 13.944L13.9418 17.1227C12.8439 18.2216 11.0592 18.2232 9.9527 17.1222C9.95286 17.1223 9.95254 17.122 9.9527 17.1222L6.87557 14.0422C5.77776 12.9434 5.77605 11.1573 6.87571 10.0498C6.876 10.0495 6.87628 10.0493 6.87656 10.049L10.0576 6.87907L10.0584 6.87825Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 9.15385C14.2435 9.15385 14.8462 9.75654 14.8462 10.5C14.8462 11.2435 14.2435 11.8462 13.5 11.8462C12.7565 11.8462 12.1538 11.2435 12.1538 10.5C12.1538 9.75654 12.7565 9.15385 13.5 9.15385ZM16 10.5C16 9.11929 14.8807 8 13.5 8C12.1193 8 11 9.11929 11 10.5C11 11.8807 12.1193 13 13.5 13C14.8807 13 16 11.8807 16 10.5Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default __webpack_public_path__ + "static/media/promotion.d97cc2d3.svg";
export { ForwardRef as ReactComponent };